<template>
  <div class="">
    <div class="mb-2 flex justify-between text-xs text-gray-700 sm:text-sm">
      <span class="text-center">Ajustar</span>
      <span class="text-center">Recomendar</span>
      <span class="text-center">Confirmar</span>
    </div>
    <div class="h-0.5 w-full rounded bg-gray-200 sm:h-1">
      <div
        class="h-0.5 rounded bg-gray-500 transition-all duration-300 sm:h-1"
        :style="{ width: `${stepToPercentage(currentStep)}%` }"
      />
    </div>
  </div>
</template>

<script lang="ts" setup>
type StepName = 'adjust' | 'recommend' | 'confirm';

interface SubOrderModificationsProgressBarProps {
  currentStep: StepName;
}

const stepToPercentage = (step: StepName): number => {
  const stepProgressMap = {
    adjust: 0,
    recommend: 50,
    confirm: 100,
  };
  return stepProgressMap[step];
};

defineProps<SubOrderModificationsProgressBarProps>();
</script>
